Librarian.Modules.Thumbnail = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onLoadData", "onClick"],

    options: {
        classPrefix: "modules-thumbnail-",
        filename: null,
        size: "lg",
        preview: true,
        caption: null
    },

    data: null,

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);

        if (this.options.filename)
            this.getFileInfo(this.options.filename);
    },

    getFileInfo: function(filename) {
        new Librarian.Request.JSON({
            url: Librarian.path.getMethodUrl("getfi") + "&out=ljson&fname=" + encodeURIComponent(filename),
            onSuccess: this.onLoadData,
            onFailure: Librarian.Utils.onFailure
        }).send();
    },

    onLoadData: function(data) {
        this.data = data;
        this.render();
    },

    render: function() {
        var size = this.options.size,
            data = this.data,
            url = Librarian.Utils.getThumbnailUrl(size, data);

        var imageWrapper = new Element("div", {
            "class": this.options.classPrefix + "image-wrapper"
        }).injectInside(this.containerEl);

        var image = new Element("img", {
            "class": this.options.classPrefix + "image",
            src: url
        }).injectInside(imageWrapper);

        if (this.options.preview) {
            image.addClass("pointer");
            image.addOnClick(this.onClick);
        }

        if (this.isVideo()) {
            var playButton = new Element("div", {
                "class": this.options.classPrefix + "play-button"
            }).injectInside(imageWrapper);
        }

        if (this.options.caption) {
            var caption = new Element("div", {
                html: this.options.caption
            }).injectInside(this.containerEl);
        }
    },

    isVideo: function() {
        var ext = Librarian.Utils.getExtensionFromData(this.data);
        
        return Librarian.extensions.isVideo(ext);
    },

    onClick: function() {
        Librarian.PreviewWindow.openPreviewWindow(this.data);
    }
});